module.exports = __webpack_public_path__ + "img/courses.73d27b12.svg";